"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteCoffeeBook = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 125 85",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("defs", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0.655051158,0 L32.4959498,0 C32.7367195,3.74949709e-15 32.931902,0.195182447 32.931902,0.435952197 L32.931902,26.1830563 C32.931902,29.945084 29.882176,32.9948099 26.1201484,32.9948099 L7.03085258,32.9948099 C3.26882493,32.9948099 0.219098961,29.945084 0.219098961,26.1830563 L0.219098961,0.435952197 C0.219098961,0.195182447 0.414281408,-8.99460885e-16 0.655051158,0 Z",
        id: "mysite-coffee-book-path-1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        id: "mysite-coffee-book-path-3",
        x: "54.4940289",
        y: "4.54116908",
        width: "38.5999371",
        height: "9.08233815"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-791.000000, -1044.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(791.000000, 1044.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M72.5594645,13.8516878 C64.5535339,13.5730017 56.9277859,10.9748227 49.646854,8.13265774 C42.365922,5.29049278 35.1524061,2.14036337 27.338777,0.634156923 C22.3124143,-0.334196107 16.5643683,-0.470828226 12.5149854,2.23687336 C8.6170123,4.83938991 7.35821124,9.34391229 6.68184049,13.5144451 C6.17235213,16.6591526 5.8728481,19.9610954 7.26758641,22.9019391 C8.23683006,24.9438302 9.95759676,26.6593224 11.1478766,28.6144629 C15.2867792,35.4189593 12.3635756,43.8099065 7.87433073,50.4539143 C5.77448701,53.5704279 3.3287216,56.5438029 1.70521086,59.8609273 C0.0817000563,63.1780516 -0.669822951,66.9798943 0.750334544,70.3642501 C2.15944019,73.7193277 5.51476949,76.238347 9.14970949,78.010227 C16.5334232,81.6103751 25.2345126,82.6405376 33.7189865,83.223935 C52.500431,84.5154338 71.3824469,83.9558931 90.2136249,83.3963518 C97.1828955,83.1881504 104.182006,82.9788649 111.038549,81.8955675 C114.844792,81.2937353 118.774815,80.3394792 121.537767,78.0340836 C125.046717,75.1062523 125.916494,70.1538802 123.564669,66.4854165 C119.624699,60.3337176 108.719879,58.8069082 105.963558,52.2008536 C104.446145,48.5660054 106.00445,44.5169235 108.209286,41.1401582 C112.93946,33.9084154 120.868027,27.5636969 121.285786,19.2963693 C121.573133,13.6185457 117.761364,7.93204707 111.86854,5.24603312 C105.690578,2.42664019 97.125426,2.78448622 92.56766,7.44515958 C87.8750619,12.2522246 79.6282018,14.0989269 72.5594645,13.8516878 Z",
            fill: "#E6EDFB",
            fillRule: "nonzero",
            className: "fill-primary",
            opacity: "0.1"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(57.048437, 15.894092)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M0,68.1175361 L0,0 L59.8866672,0 L59.8866672,68.1175361 L0,68.1175361 Z",
              className: "fill-primary-opa50",
              fill: "#88A9F0"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary",
              fill: "#1657E2",
              x: "0",
              y: "0",
              width: "18.1646763",
              height: "11.3529227"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary",
              fill: "#1657E2",
              x: "0",
              y: "18.1646763",
              width: "18.1646763",
              height: "38.5999371"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary-opa50",
              fill: "#88A9F0",
              x: "5.67646135",
              y: "24.9764299",
              width: "6.81175361",
              height: "20.4352608"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary",
              fill: "#1657E2",
              x: "26.3955453",
              y: "20.4352608",
              width: "27.2470145",
              height: "4.54116908"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary",
              fill: "#1657E2",
              x: "30.0852451",
              y: "29.517599",
              width: "19.8676147",
              height: "4.54116908"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(18.164676, 32.923476)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
                fill: "white",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                  xlinkHref: "#mysite-coffee-book-path-1"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fill: "#C3D0D8",
                xlinkHref: "#mysite-coffee-book-path-1"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M-8.47410317,0 L23.3667954,0 C23.6075652,3.74949709e-15 23.8027476,0.195182447 23.8027476,0.435952197 L23.8027476,26.1830563 C23.8027476,29.945084 20.7530217,32.9948099 16.990994,32.9948099 L-5.42243779,32.9948099 C-7.34859579,32.9948099 -8.91005537,31.4333504 -8.91005537,29.5071924 L-8.91005537,0.435952197 C-8.91005537,0.195182447 -8.71487292,-8.99460885e-16 -8.47410317,0 Z",
                fill: "#FFFFFF",
                mask: "url(#mask-2)"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#091E43",
              x: "0.283823067",
              y: "4.54116908",
              width: "32.6396527",
              height: "4.82499214"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#091E43",
              x: "23.5573146",
              y: "4.54116908",
              width: "9.36616122",
              height: "4.82499214"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M32.9234758,4.82499214 C38.0962638,4.82499214 42.289637,9.01836536 42.289637,14.1911534 C42.289637,19.3639414 38.0962638,23.5573146 32.9234758,23.5573146 L32.9234758,18.874234 L32.9234758,18.874234 C35.5098698,18.874234 37.6065564,16.7775474 37.6065564,14.1911534 C37.6065564,11.6047594 35.5098698,9.50807275 32.9234758,9.50807275 L32.9234758,4.82499214 L32.9234758,4.82499214 Z",
              fill: "#C3D0D8"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(8.230869, 65.846952)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M54.4940289,18.1646763 L54.4940289,13.6235072 L93.0939661,13.6235072 L93.0939661,4.54116908 L54.4940289,4.54116908 L54.4940289,0 L97.6351351,0 L97.6351351,18.1646763 L54.4940289,18.1646763 Z",
              className: "fill-primary",
              fill: "#1657E2"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                className: "fill-primary",
                fill: "#1657E2",
                xlinkHref: "#mysite-coffee-book-path-3"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
                fillOpacity: "0.8",
                fill: "#FFFFFF",
                xlinkHref: "#mysite-coffee-book-path-3"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary-opa50",
              fill: "#88A9F0",
              x: "0",
              y: "0",
              width: "54.4940289",
              height: "4.54116908"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              fill: "#FFFFFF",
              x: "2.27058454",
              y: "4.54116908",
              width: "52.2234444",
              height: "9.08233815"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              className: "fill-primary-opa50",
              fill: "#88A9F0",
              x: "0",
              y: "13.6235072",
              width: "54.4940289",
              height: "4.54116908"
            })]
          })]
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteCoffeeBook')(IllustrationMySiteCoffeeBook);